import { useEffect, useState } from 'react';
import { Modal, Form, Input, App, Typography, Space, Descriptions } from 'antd';
import {
    useThirdPartyGenerateBillingBatchBySelectMutation,
    useThirdPartyDetailCalculationBulkOperationBySearchMutation,
} from '../../../features/api/apiSlice';
const { Text } = Typography;
const CONVERT_STATUS = {
    '4': '待计算',
    '5': '计费异常',
    '6': '待出账',
    '7': '已出账',
}
function GenerateBillingBatchModal ({ open, setOpen, data, target, selectedRowKeys, setSelectedRowKeys, billingInvoiceNames, customerUidData }) {
    const { notification } = App.useApp();
    const [convertedContent, setConvertedContent] = useState(data);
    const [form] = Form.useForm();
    const [generateBillingBatchBySelect, { 
        isLoading: isGenerateBySelectLoading,
        isSuccess: isGenerateBySelectSuccess,
        isError: isGenerateBySelectError,
        error: generateBySelectError,
    }] = useThirdPartyGenerateBillingBatchBySelectMutation();

    const [generateBillingBatchBySearch, {
        isLoading: isGenerateBySearchLoading,
        isSuccess: isGenerateBySearchSuccess,
        isError: isGenerateBySearchError,
        error: generateBySearchError,
    }] = useThirdPartyDetailCalculationBulkOperationBySearchMutation();

    const getUid = (customerId) => {
        const customer = customerUidData.find(item => item.id === customerId);
        if (customer) {
            return customer.uid;
        }
        return null;
    }

    const getBillingInvoiceName = (billingInvoiceId) => {
        const billingInvoice = billingInvoiceNames.find(item => item.id === billingInvoiceId);
        if (billingInvoice) {
            return billingInvoice.name;
        }
        return null;
    }

    useEffect(() => {
        if (target === 'search') {
            setConvertedContent({
                '状态': CONVERT_STATUS[data.status],
                'Tracking Number': data.tracking_number,
                'Master Tracking': data.master_tracking_number,
                'UID': getUid(data.uid),
                'Shipment Date': data.shipment_date,
                '物流服务': data.service_type,
                '导入批次编号': getBillingInvoiceName(data.billing_invoice),
            })
        }
    }, [data, target]);

    useEffect(() => {
        if (isGenerateBySelectSuccess) {
            notification.success({
                message: '成功',
                description: '生成出账批次成功',
            })
            setOpen(false);
            form.resetFields();
            setSelectedRowKeys([]);
        }
        if (isGenerateBySelectError) {
            notification.error({
                message: '失败',
                description: generateBySelectError?.data?.message,
            })
        }
    }, [isGenerateBySelectSuccess, isGenerateBySelectError]);

    useEffect(() => {
        if (isGenerateBySearchSuccess) {
            notification.success({
                message: '成功',
                description: '生成出账批次成功',
            })
            setOpen(false);
            form.resetFields();
        }
        if (isGenerateBySearchError) {
            notification.error({
                message: '失败',
                description: generateBySearchError?.data?.message,
            })
        }
    }, [isGenerateBySearchSuccess, isGenerateBySearchError]);
    const handleOk = () => {
        form.validateFields().then(values => {
            if (target === 'search') {
                generateBillingBatchBySearch({
                    ...data,
                    billing_batch_name: values.billing_batch_name,
                    operation: 'generateInvoice',
                })
            } else if (target === 'select') {
                const formData = new FormData();
                formData.append('detail_ids', selectedRowKeys);
                formData.append('billing_batch_name', values.billing_batch_name);
                generateBillingBatchBySelect(formData);
            }
        }).catch(error => {
            console.log(error);
        })
    }
    
    return (
        <Modal
            title="出账批次输入"
            open={open}
            onCancel={() => setOpen(false)}
            onOk={handleOk}
            centered
            confirmLoading={isGenerateBySelectLoading || isGenerateBySearchLoading}
        >
            <Space direction="vertical">
                {target === 'search' ? <Text>将对以下查询结果进行处理：</Text> : <Text>将对以下内容进行处理：</Text>}
                {target === 'search' ? (
                    <Descriptions column={1} layout="vertical" size="small">
                        {Object.entries(convertedContent).map(([key, value], index) => {
                                if (value) {
                                    if (key === 'Tracking Number') {
                                        // take the first 12 tracking number
                                        return <Descriptions.Item>{key}: {value.split(',').slice(0, 12).join(", ")}{value.length > 12 ? "..." : ""}</Descriptions.Item>
                                    }
                                    return <Descriptions.Item>{key}: {value}</Descriptions.Item>
                                }
                            }
                            )
                        }
                    </Descriptions>
                ) : (
                    // only show the first 20, if there are more than 20, use elipsis
                    <Space direction="horizontal">
                        <Text style={{ whiteSpace: 'nowrap' }}>
                            Tracking Number:
                        </Text>
                        <Text>
                            {data.slice(0, 12).map(item => item.tracking_number).join(', ')}
                            {data.length > 12 ? "..." : ""}
                        </Text>
                    </Space>
                )}
            </Space>
            <Form
                form={form}
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 18,
                }}
                style={{
                    marginTop: '20px',
                    marginLeft: '0',
                    marginRight: '20%',
                    maxWidth: '60%'
                }}
            >
                <Form.Item label="出账批次" name="billing_batch_name">
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default GenerateBillingBatchModal;